import fddapis  from "../../api/fdd";
export default {
    name: "Template",
    data() {
        return {
            detailVisible:false,
            changeVisible:false,
            dataDetail:{},
            paramList:[],
            fileList:[],
            type:"",
            query: {
                keyword: "",
                pageIndex: 1,
                pageSize: 100
            },
            tableCols:[
                {
                    "prop": "FddTemplateId",
                    "label": "法大大模板编号",
                    "width": "180",
                    "align": "center"
                },
                {
                    "prop": "Name",
                    "label": "模板名称",
                    "width": "",
                    "align": "center"
                },
                {
                    "prop": "Type",
                    "label": "类型",
                    "width": "100",
                    "align": "center"
                },
                {
                    "prop": "myParty",
                    "label": "参与方",
                    "width": "200",
                    "align": "center"
                },
                {
                  "prop": "IsSelect",
                  "label": "是否生效",
                  "width": "100",
                  "align": "center"
                },
                {
                    "prop": "CreateTime",
                    "label": "更新时间",
                    "width": "160",
                    "align": "center"
                },
                {
                    "prop": "Operation",
                    "label": "操作",
                    "width": "300",
                    "align": "center"
                }
            ],
            partyList:[{Id:"1",Name:"我司"},{Id:"2",Name:"用户"},{Id:"3",Name:"银行"}],
            newPartys:[],
            configParam:{IsShow:"",Name:""},
            tableData:[],
            pageTotal: 0,
            scrollHeight:400,
            checkedlist:[],
            editVisible:false,
            wxMessageVisible:false,
            returnItem:null,
            rules: {
              LoanName: [
                { required: true, message: '请填写贷款类型名称', trigger: 'change' },
              ],
              MinMoney: [
                  { required: true, message: '请填写最低贷款金额', trigger: 'change' },
                  { type: 'integer', message: '最低贷款金额必须为数值', trigger: 'change'}
              ],
              MaxMoney:[
                  { required: false, message: '请填写最高贷款金额', trigger: 'change' },
                  { type: 'integer', message: '最高贷款金额必须为数值', trigger: 'change'},
              ],
              RatStart: [
                  { required: true, message: '请填写最低利率', trigger: 'change' },
                  {
                      validator(rule, value, callback) {
                      var reg = /^-?\d{1,5}(?:\.\d{1,2})?$/
                          if (reg.test(value)) {
                              callback()
                          } else {
                              callback(new Error('请输入不超过两位小数的数字'))
                          }
                      },
                      trigger: 'change'
                  }
              ],
              RatEnd:[
                  { required: true, message: '请填写最高利率', trigger: 'change' },
                  {
                      validator(rule, value, callback) {
                      var reg = /^-?\d{1,5}(?:\.\d{1,2})?$/
                          if (reg.test(value)) {
                              callback()
                          } else {
                              callback(new Error('请输入不超过两位小数的数字'))
                          }
                      },
                      trigger: 'change'
                  }
              ],
              BaseMoney: [
                  { required: true, message: '请填写基准额度', trigger: 'change' },
                  { type: 'integer', message: '基准额度必须为数值', trigger: 'change'}
              ],
          },
          loantableCols:[
            {
                "prop": "LoanName",
                "label": "贷款名称",
                "align": "center"
            },
            {
                "prop": "MaxMoney",
                "label": "最高贷金额(万元)",
                "width": "160",
                "align": "center"
            },
            {
                "prop": "RatStart",
                "label": "参考利率(‱)",
                "align": "center"
            },
            {
                "prop": "Tips1",
                "label": "付息信息",
                "align": "center"
            },
            {
                "prop": "Tips2",
                "label": "贷款时长",
                "align": "center"
            },
            {
                "prop": "IsShow",
                "label": "是否生效",
                "align": "center"
            },
            {
              "prop": "IsCodeShow",
              "label": "短信验证码",
              "align": "center"
            },
            {
                "prop": "Operation",
                "label": "操作",
                "width": "180",
                "align": "center"
            }
        ],
        loantableData: [],
        };
    },
    created() {
      this.getData();
      this.getYjConfig()
      // this.getParams();
    },
    mounted() {
      let that = this;
      that.calcTableHeight();
      // 注：window.onresize只能在项目内触发1次
      window.onresize = function windowResize () {
        that.calcTableHeight();
      }
    },
    methods: {
        getData(){
          let param=this.query;
          fddapis.getTemplateList(param).then(res => {
                            this.$data.tableData=res.list;
                            this.$data.pageTotal=res.count
                    });
    
        },
        getYjConfig(){
          fddapis.getYjConfig({}).then(res => {this.$data.loantableData=[];
                            this.$data.loantableData.push(res);
                    });
    
        },
        getParams(){
          fddapis.getTemplateParamList().then(res => {
                        var data=[{label:'用户数据',Id:1,children:[]},
                        {label:'银行数据',Id:2,children:[]},
                        {label:'业务数据',Id:3,children:[]},
                        {label:'系统数据',Id:4,children:[]}]
                         
                          for(var i=0;i<res.length;i++){
                            var  type=res[i].Type-1;
                            data[type].children.push({
                              label:res[i].Name+" "+res[i].Code,
                              Id:res[i].Id
                            })
                          }
                          this.paramList=data
                    });
    
        },
        getPartyName(row){
               var name="";
               var list=row.Partys.split(",");
               for(var i=0;i<list.length;i++){
                if(list[i]=="1")name+=",我司";
                 else if(list[i]=="2")name+=",用户"
                 else  if(list[i]=="3")name+=",银行"
               }
               if(name=="")name="无";else name=name.substring(1);
               return name ;

        },
        uploadFile(item){
          let that = this
          let fileObj = item.file
          const form = new FormData()
          form.append("file",fileObj)
          this.$refs.templateUpload.clearFiles();
          fddapis.uploadFileToFdd(form).then(res => {
            if(res.code){
              that.$message.success("新增成功");
              that.getData();
             }else {
              that.$message.error(res.msg);
             }
          });
      },
      uploadRemove(){
         this.fileList=[]
      },
      addOrUpdate(){
          let param=this.dataDetail;
          if(param.Name==""){
            this.$message.error("名称不能为空");
            return;
          }
         if(param.FddTemplateId==""){
            this.$message.error("模版Id不能为空");
            return;
          }
          if(this.type=="add"){
            this.addTemplate(param);
          }
          else this.updateTemplate(param);
      
      },
      addTemplate(param){
         param.Partys=this.newPartys.join(',');
        fddapis.addTemplate(param).then(res => {
          if(res.code){
           this.$message.success("新增成功");
             this.getData();
             this.$data.detailVisible=false;
             this.$refs.templateUpload.clearFiles();
          }else {
            this.$message.error(res.msg);
          }
      });
      },
      handlePicDownload(data) {
        // if(data){
        //   let blob = new Blob([data.Url], {
        //     type: "application/pdf;charset-UTF-8"
        //   });
        //   let filename = data.Name;
        //   if (typeof window.navigator.msSaveBlob !== "undefined") {
        //     window.navigator.msSaveBlob(blob, filename);
        //   } else {
        //     var blobURL = window.URL.createObjectURL(blob);
        //     // 创建隐藏<a>标签进行下载
        //     var tempLink = document.createElement("a");
        //     tempLink.style.display = "none";
        //     tempLink.href = blobURL;
        //     tempLink.setAttribute("download", filename);
        //     if (typeof tempLink.download === "undefined") {
        //       tempLink.setAttribute("target", "_blank");
        //     }
        //     document.body.appendChild(tempLink);
        //     tempLink.click();
        //     document.body.removeChild(tempLink);
        //     window.URL.revokeObjectURL(blobURL);
        //   }
        // }
      },
      updateTemplate(param){
        // let checkedNodes = this.$refs.paramTree.getCheckedKeys(true);
        // param.Params=checkedNodes.join(',')
        param.Partys=this.newPartys.join(',');
        fddapis.updateTemplate(param).then(res => {
                 if(res.code){
                  this.$message.success("修改成功");
                  this.getData();
                  this.$data.detailVisible=false;
                //   this.$refs.paramTree.setCheckedKeys([]);
          }else {
            this.$message.error(res.msg);
          } 
                    });
      },
        // 触发搜索按钮
        refreshList() {
            this.query.pageIndex = 1;
            this.getData();
        },
        handleEmpty(){
           this.$data.query={
            keyword: "",
            pageIndex: 1,
            pageSize: 10}
        },
        // handleAdd(){
        //   document.querySelector(".templateUpload .el-upload").click();
        //   this.$data.detailVisible=true;
        //   this.$data.dataDetail={
        //     Name:"",
        //     Type:"1",
        //     IsSelect:"0"
        //   }
        //   this.fileList=[];
        //   this.type="add";
        //   this.$refs.templateUpload.clearFiles();
        // },
        handleView(row){
                     let param={Id:row.FddTemplateId}
                     var that=this;
                    fddapis.getTemplateView(param).then(res => {
                           if(res){
                              window.open(res);
                           }else{
                                  that.$message.error("预览失败");
                                }
                    });
        },
        handleUpdate(row){
          this.$data.dataDetail={
            FddTemplateId:row.FddTemplateId,
            Name:row.Name,
            Type:row.Type+"",
            IsSelect:row.IsSelect+"",
            Id:row.Id,
            FddUserName:row.FddUserName,
            FddUserCode:row.FddUserCode
          }
          var newPartys=[]
          if(row.MyParty==1)newPartys.push("1");
          this.newPartys=row.Partys?row.Partys.split(","):[],
          this.type="update";
          this.$data.detailVisible=true;
        },
       handleAdd(){
          this.$data.dataDetail={
            FddTemplateId:"",
            Name:"",
            FddTemplateId:"",
            Type:"",
            IsSelect:"",
          }
          this.newPartys=[]
          this.type="add";
          this.$data.detailVisible=true;
        },
          handleChangePhone(){
          this.$data.dataDetail={
            Id:"",
            actor:"5",
          }
          this.$data.changeVisible=true;
        },
        handleWxMessage(){
          this.$data.dataDetail={
            Id:"",
          }
          this.$data.wxMessageVisible=true;
        },
        wxMessageSend(){
             var that=this;
           var obj=this.$data.dataDetail;
           if(!obj.Id){
              that.$message.error("编号为空");
              return;
           }
           
           fddapis.sendMessage(obj).then(res => {
                              if(res.result==1){
                                  that.wxMessageVisible = false;
                                  that.$message.success("提交成功");
                              }else{
                                  that.$message.error(res.msg);
                              }
                          });
        },
        changePhone(){
          var that=this;
           var obj=this.$data.dataDetail;
           if(!obj.Id){
              that.$message.error("编号为空");
              return;
           }
           
           fddapis.changeYjUserPhone(obj).then(res => {
                              if(res){
                                  that.changeVisible = false;
                                  that.$message.success(res);
                              }else{
                                console.log(res)
                                  that.$message.error("修改失败");
                              }
                          });
        },
        // 删除操作
        handleDelete(row) {
            let that = this;
            if(row){
                that.$confirm('确定删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  let param={
                    Id:row.Id
                  };
                  fddapis.deleteTemplate(param).then(res => {
                                if(res){
                                  that.$message.success("删除成功");
                                  that.getData();
                                }else{
                                  that.$message.error("删除失败");
                                }
                            });
                }).catch(() => {
                  that.$message({
                      type: 'info',
                      message: '已取消删除'
                    });
                });
            }
        },
        // 分页导航
        handlePageChange(val) {
            this.query.pageIndex = val;
            this.getData();
        },
        handleSizeChange(val){
            this.query.pageIndex = 1;
            this.query.pageSize = val;
            this.getData();
        },
        calcTableHeight(){
          this.$nextTick(() => {
            var height1=$(".content-box .content").height();
            var height=height1-400;
            this.scrollHeight = height;
          });
        },

                // 编辑贷款类型
                addEditChange(){
                  let that = this;
                  this.$refs["loanruleForm"].validate((valid) => {
                      if (valid) {
                          let obj = Object.assign({}, this.returnItem);
                          if(!obj.MaxMoney)obj.MaxMoney=null;
                          fddapis.updateYjConfig(obj).then(res => {
                              if(res){
                                  that.editVisible = false;
                                  that.$message.success("修改成功");
                                  that.getYjConfig();
                              }else{
                                  this.$message.error("修改失败");
                              }
                          });
                      } else {
                        return false;
                      }
                  });
              },
                      handleEdit(index, row) {
                          let that = this;
                          if(row){
                              that.editVisible = true;
                              that.returnItem = row;
                              that.returnItem.IsShow+="";
                              that.returnItem.IsCodeShow+="";
                          }
                      },
    },
  
  };